import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getLocalizedPcmTestimonialForOfferId, type LocalizedPcmTestimonial } from 'constants/pcmTestimonials'

function usePcmTestimonialForOfferId(offerId: string): LocalizedPcmTestimonial | undefined {
  const intl = useIntl()

  return useMemo(
    () => getLocalizedPcmTestimonialForOfferId(intl, offerId),
    [intl, offerId],
  )
}

export default usePcmTestimonialForOfferId
